






























































































































































































































import { Component, Vue } from "vue-property-decorator";
import SectionContainer from "@/components/Commons/SectionContainer.vue";
import SectionTitle from "@/components/Commons/SectionTitle.vue";
import { vxm } from "@/store.vuex";
declare var window: any;

@Component({
  name: 'PrivacyConsent',
  components: {
    SectionContainer,
    SectionTitle,
  },
})
export default class PrivacyConsent extends Vue {
private userConsents : any = {};
private policyVersion : string = '-';
private renewalSuccess: boolean = false ;
private showWithdrawModal: boolean = false ;
private isRenewing: boolean =  false;
private isWithdrawing:  boolean = false;


  async mounted() {
    const resp = await vxm.users.getUserconsents();
    this.userConsents = resp.data
    if(this.userConsents.companyGdprConfigId){
    const companyGdprConfig =await vxm.users.getcompanyGdprConfigs(resp.data.companyGdprConfigId)
    this.policyVersion = companyGdprConfig && companyGdprConfig.data && companyGdprConfig.data.privacyPolicyVersion;
    }
  }

  get isActive() {
    return this.userConsents.consentStatus === 1;
  };

  get isGrace() {
    return this.userConsents.consentStatus === 3;
  }

  get isWithdrawn() {
    return this.userConsents.consentStatus === 0;
  }

  statusText() {
    const statusMap = {
      1: 'Active',
      3: 'Grace',
      0: 'Withdrawn'
    }
    return statusMap[this.userConsents.consentStatus] || '';
  }

  get statusClass() {
    switch (this.userConsents.consentStatus) {
      case 1:
        return 'active';

      case 2:
        return 'grace';

      case 0:
        return 'withdrawn';

      default:
        return '';
    }
  }

  async renewConsent(){
    if (this.isRenewing) {
      return;
    }
    try{
      this.isRenewing = true;
      await vxm.users.renewConsent();
      const resp = await vxm.users.getUserconsents();
      this.userConsents = resp.data
      if(this.userConsents.companyGdprConfigId){
        const companyGdprConfig =await vxm.users.getcompanyGdprConfigs(resp.data.companyGdprConfigId)
        this.policyVersion = companyGdprConfig && companyGdprConfig.data && companyGdprConfig.data.privacyPolicyVersion;
      }
      this.renewalSuccess = true;
    }catch (error) {
      console.error('Failed to renew consent:', error);
    } finally {
      this.isRenewing = false;
    }
  }

  async confirmWithdraw(){
    if (this.isWithdrawing) {
      return;
    }
    this.isWithdrawing = true;
    try{
      await vxm.users.withdrawconsent();
      this.showWithdrawModal = false;
      const resp = await vxm.users.getUserconsents();
      this.userConsents = resp.data
      if(this.userConsents.companyGdprConfigId){
        const companyGdprConfig =await vxm.users.getcompanyGdprConfigs(resp.data.companyGdprConfigId)
        this.policyVersion = companyGdprConfig && companyGdprConfig.data && companyGdprConfig.data.privacyPolicyVersion;
      }
      this.renewalSuccess = false;
    }catch(error){
      console.error('Failed to withdraw consent:', error);
    }finally{
      this.isWithdrawing = false;
    }

  }

  openWithdrawModal() {
    this.showWithdrawModal = true;
  }

  closeWithdrawModal() {
    this.showWithdrawModal = false;
  }

  formatDate(date) {
    if (!date) {
      return '-';
    }
    const d = new Date(date);
    return d.toLocaleDateString(vxm.users.getUserLang,{
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }

}
